<template>
	<div>
		<Modal v-model="isShow" footer-hide :width="750">
			<div slot="header"><b>取消装箱提示</b></div>
			<div style="padding: 20px;">
				<Form label-position="left">
					<FormItem>
						<span slot="label">请选择要取消的箱号：</span>
						<RadioGroup v-model="cancelBoxType">
							<Radio :label="1"><span>全部箱号</span></Radio>
							<Radio :label="2"><span>部分箱号</span></Radio>
						</RadioGroup>
					</FormItem>
					<FormItem v-if="cancelBoxType==2">
						<Button type="primary" :ghost="deleteIds.includes(item.id)?false:true" v-for="(item,index) of packingBoxList"
						        :key="index" size="large" style="margin-right: 10px;margin-top:10px;" @click="clickBoxCallback(item)">
							{{item.box_no_title}}
						</Button>
						<!--<Tag v-for="(item,index) of packingBoxList" :key="index" checkable size="large" type="primary">

						</Tag>-->
					</FormItem>
					<span style="color: #e13d13">若取消全部箱号后订单将会变更为未集包</span>
				</Form>
			</div>
			<div>
				<Button size="large" icon="md-close" style="width: 48%;" @click="isShow=false">取消</Button>
				<Button size="large" icon="md-checkmark-circle" style="width: 50%;" type="primary" @click="doCancelBox"
				        :disabled="cancelBoxType==2 && !deleteIds.length" :loading="buttonLoading">
					<span v-if="cancelBoxType==2 && !deleteIds.length">请选择要取消的箱号</span>
					<span v-else>确认</span>
				</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	// import {changeUnit} from "@/libs/util";
	import {queryPackingBoxList, doCancelBox} from "@/api/sorting/packingBox"

	export default {
		name: "cancelBox",
		props: {
			// 分拣数据
			/*sortingData: {
				type: Object,
				default: {}
			},*/
		},
		data() {
			return {
				buttonLoading: false,
				isShow: false,
				sortingData: {},
				// 取消类型
				cancelBoxType: 1,
				// 箱子列表
				packingBoxList: [],
				// 删除的id
				deleteIds: []
			};
		},
		methods: {
			// 点击箱子回调
			clickBoxCallback(item) {
				if (this.deleteIds.includes(item.id)) {
					this.deleteIds.splice(this.deleteIds.indexOf(item.id), 1);
				} else {
					this.deleteIds.push(item.id);
				}
			},
			// 查询关联称重框
			queryPackingBoxList(item) {
				this.isShow = true;
				this.cancelBoxType = 1;
				this.sortingData = item;
				this.deleteIds = [];
				queryPackingBoxList({pack_id: this.sortingData.id}).then(data => {
					if (data.data.code == 1200) {
						this.packingBoxList = data.data.data;
					}
				});
			},
			// 删除箱子
			deleteBox(index) {
				this.deleteIds.push(this.packingBoxList[index].id);
				this.packingBoxList.splice(index, 1);
			},
			// 取消装箱
			doCancelBox() {
				let cancelAll = true;
				if (this.cancelBoxType == 2 && this.deleteIds.length != this.packingBoxList.length) {
					cancelAll = false;
				}
				let param = {cancelBoxType: this.cancelBoxType, deleteIds: this.deleteIds, packId: this.sortingData.id, cancelAll};
				this.buttonLoading = true;
				doCancelBox(param).then(data => {
					if (data.data.code == 1200) {
						this.$emit("cancelBoxSubmit", {});
						this.isShow = false;
					} else {
						this.$Message.error(data.data.msg)
					}
					this.buttonLoading = false;
				});
			}
		},
		mounted() {
		},
		destroyed() {
		},
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/boxManage/cancelBox.vue